const favourite_book  = `One of my favorite books is called "Atomic Habits.
It talks about how small changes can make a big difference in our lives. 
The book explains that if we want to change something, we should start with small habits.
The author says that if we do something little every day, it can add up to something big over time. 
He gives examples of how people can improve their lives by making small changes. 
He talks about how our habits can shape who we become and how we can achieve our goals by focusing on the little things we do every day.
The book is easy to read and has many stories that help explain the ideas.
It has practical tips that anyone can use to make positive changes in their life. 
It's a book that can inspire and motivate people to work towards their goals, one small step at a time.
Overall, "Atomic Habits" is a book that can teach us how to make lasting changes in our lives by focusing on small, everyday habits. 
It's a great book for anyone who wants to improve themselves and achieve their goals.`;

export default favourite_book;